jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const run = (fn) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(fn);
    else fn();
  };

  const onGsapReady = (cb) => {
    if (window.gsap) return cb();
    document.addEventListener("longevity:gsap-ready", cb, { once: true });
  };

  const onScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    document.addEventListener("longevity:scroll-ready", runOnce, {
      once: true,
    });
    setTimeout(runOnce, 0);
  };

  run(() => {
    onGsapReady(() => {
      onScrollReady(() => {
        initPostCardsGrid();
      });
    });
  });

  function initPostCardsGrid() {
    const blocks = document.querySelectorAll(".js-post-cards-grid");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.pcgInit === "1") return;
      block.dataset.pcgInit = "1";

      const items = block.querySelectorAll(".js-pcg-item");
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      const vars = {
        autoAlpha: 1,
        y: 0,
        duration: 0.95,
        ease: "power3.out",
        stagger: 0.08,
        clearProps: "transform",
      };

      if (ScrollTrigger) {
        vars.scrollTrigger = {
          trigger: block,
          start: "top 75%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      gsap.to(items, vars);
    });
  }
});
